import { useEffect, useRef } from 'react';

interface OriginalStyles {
  overflow: string;
  position: string;
  top: string;
  width: string;
  height: string;
}

type UseLockScrollProps = {
  isShowingProducts: boolean;
};

export const useLockScroll = ({ isShowingProducts }: UseLockScrollProps) => {
  const originalStyles = useRef<OriginalStyles | null>(null);
  const scrollPosition = useRef<number>(0);

  const lockScroll = () => {
    const body = document.body;
    scrollPosition.current = window.scrollY;

    if (!originalStyles.current) {
      originalStyles.current = {
        overflow: body.style.overflow,
        position: body.style.position,
        top: body.style.top,
        width: body.style.width,
        height: body.style.height,
      };
    }

    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition.current}px`;
    body.style.width = '100%';
    body.style.height = '100%';
  };

  const unlockScroll = () => {
    const body = document.body;

    if (originalStyles.current) {
      body.style.overflow = originalStyles.current.overflow;
      body.style.position = originalStyles.current.position;
      body.style.top = originalStyles.current.top;
      body.style.width = originalStyles.current.width;
      body.style.height = originalStyles.current.height;

      window.scrollTo(0, scrollPosition.current);

      originalStyles.current = null;
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: This effect intentionally doesn't include all dependencies
  useEffect(() => {
    if (isShowingProducts) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => {
      if (originalStyles.current) {
        unlockScroll();
      }
    };
  }, [isShowingProducts]);
};
